import { Copy, MessageCircle } from "lucide-react";
import { toast } from "sonner";
import { formatRange, rupiah, waLink } from "@/lib/format";

const copy = (text) => {
  navigator.clipboard?.writeText(text);
  toast.success("Disalin");
};

const Row = ({ label, value, strong, testId }) => (
  <div className="flex items-baseline justify-between gap-4 py-2 text-sm">
    <span className="text-neutral-500">{label}</span>
    <span className={`font-mono ${strong ? "text-lg text-gold-light" : "text-neutral-200"}`} data-testid={testId}>{value}</span>
  </div>
);

const BankList = ({ accounts }) => (
  <div className="space-y-3">
    {accounts.map((b, i) => (
      <div key={i} className="flex items-center justify-between gap-3 rounded-xl border border-white/10 bg-black/40 p-4" data-testid={`order-bank-${i}`}>
        <div>
          <p className="text-xs uppercase tracking-[0.2em] text-neutral-500">{b.bank}</p>
          <p className="mt-1 font-mono text-lg">{b.number}</p>
          <p className="text-xs text-neutral-400">a.n. {b.holder}</p>
        </div>
        <button type="button" onClick={() => copy(b.number)} className="flex h-10 w-10 items-center justify-center rounded-full border border-white/10 hover:border-gold hover:text-gold" data-testid={`order-bank-copy-${i}`}>
          <Copy className="h-4 w-4" />
        </button>
      </div>
    ))}
  </div>
);

export const PaymentInfo = ({ order, settings }) => {
  const remaining = Math.max(0, order.total_price - order.amount_paid);
  const dp = Math.ceil((order.total_price * (settings?.dp_percent ?? 0)) / 100);
  const paidOff = remaining === 0 || ["lunas", "selesai"].includes(order.status);
  const message = `Halo ${settings?.business_name || ""}, saya ingin konfirmasi pembayaran pesanan ${order.code} (${order.trip_name} - ${order.package_name}, ${formatRange(order.start_date, order.end_date)}) atas nama ${order.customer_name}.`;
  return (
    <div className="panel space-y-6 p-6 sm:p-8" data-testid="order-payment-info">
      <div>
        <p className="overline-label">Pembayaran</p>
        <div className="mt-4 divide-y divide-white/5">
          <Row label="Total" value={rupiah(order.total_price)} testId="order-total" />
          <Row label="Sudah dibayar" value={rupiah(order.amount_paid)} testId="order-paid" />
          <Row label="Sisa" value={rupiah(remaining)} strong testId="order-remaining" />
          {!paidOff && order.amount_paid === 0 && settings?.dp_percent > 0 && (
            <Row label={`DP minimal (${settings.dp_percent}%)`} value={rupiah(dp)} testId="order-dp" />
          )}
        </div>
      </div>
      {paidOff ? (
        <p className="rounded-xl border border-emerald-400/30 bg-emerald-400/10 p-4 text-sm text-emerald-200" data-testid="order-paid-off">Pembayaran sudah lunas. Sampai jumpa di jalur!</p>
      ) : (
        <>
          {settings?.bank_accounts?.length > 0 && <BankList accounts={settings.bank_accounts} />}
          {settings?.payment_note && <p className="text-sm leading-relaxed text-neutral-400">{settings.payment_note}</p>}
        </>
      )}
      {settings?.whatsapp ? (
        <a href={waLink(settings.whatsapp, message)} target="_blank" rel="noreferrer" className="btn-gold w-full" data-testid="order-wa-confirm-btn">
          <MessageCircle className="h-4 w-4" /> Konfirmasi via WhatsApp
        </a>
      ) : (
        <p className="text-center text-xs text-neutral-500" data-testid="order-wa-missing">Nomor WhatsApp admin belum diatur.</p>
      )}
    </div>
  );
};
